import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { BaseClass } from '../../utility/baseClass';
import { ApplicationlogsService } from '../../main-layout/applicationlogs/applicationlogs.service';
import { SortEvent } from 'primeng/api';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-errorlogmodal',
  templateUrl: './errorlogmodal.component.html',
  styleUrls: ['./errorlogmodal.component.css']
})
export class ErrorlogmodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Close Log';
  modalForm: FormGroup;
  rowsize: number = 10;
  commonScrollHeight = '';
  cols = [];
  @ViewChild('dt') dt: any;
  public options = [];
  occurrenceData: any[] = [];
  currentPageIndex: number = 0;
  isEdit: boolean = false;
  paginatorArray = []
  searchTerm: string = '';
  selectedRow: any;
  onlyView: boolean = false;
  isClose: boolean = false;
  isViewClosureData: boolean = false;
  _selectedColumns = [];
  searchText: string;
  viewClosureData: boolean;
  public totalRecords: number = 0;
  tablecount: number = 0;
  closeRemarks = '';
  confirmClose = false;
  remarksError = false;
  identicalLogs: any[] = [];

  pageName = "";
  methodName = "";
  viewMode = "";
  errorAge = "";
  productId = "";
  orgId = "";
  fromDate = "";
  toDate = "";
  isClosingLog = false;
  selectedDate = "";
  selectedHour: number;
  closureLogId = "0";
  @ViewChild('identicalDt') identicalDt: any;

  identicalRowsize: number = 10;
  identicalCurrentPageIndex: number = 0;
  identicalPaginatorArray: number[] = [];
  identicalSearchTerm: string = '';

  identicalSelectedColumns: any[] = [];
  selectedValues = [];
  identicalGlobalFilterFields: string[] = [
    'id',
    'data',
    'createdAt'
  ];

  public validation_message = {
    'closeRemarks': [
      { type: 'required', message: 'Remarks is required.' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ]
  };

  constructor(
    private ApplicationlogsService: ApplicationlogsService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector, public dialogService: DialogService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    if (dataFromParent) {
      this.selectedRow = dataFromParent.selectedRow;
      this.onlyView = dataFromParent.onlyView ?? false;
      this.isClose = dataFromParent.isClose ?? false;
      this.closureLogId = dataFromParent.logId ?? false;
      this.isViewClosureData = dataFromParent.isViewClosureData ?? false;
      this.viewMode = dataFromParent.viewMode ?? '';
      this.errorAge = dataFromParent.errorAge ?? '';
      if (this.isViewClosureData == true) {
        this.methodName = dataFromParent.methodName;
        this.pageName = dataFromParent.pageName;
      }

      if (this.isClose == true) {
        this.commonScrollHeight = this.utilityservice.updateScrollHeight()
        this.logIdenticalGrid();

      }

      if (this.viewMode == "Error Age Data" || this.viewMode == "Open Errors by Product" || this.viewMode == "Weekly Trend"
        || this.viewMode == "Heat Map"
      ) {
        this.productId = dataFromParent.productId;
        this.orgId = dataFromParent.orgId;

        if (this.viewMode == "Open Errors by Product") {
          this.fromDate = dataFromParent.fromDate;
          this.toDate = dataFromParent.toDate;
        }

        if (this.viewMode == "Weekly Trend") {
          this.selectedDate = dataFromParent.selectedDate;
        }
        if (this.viewMode == "Heat Map") {
          this.selectedDate = dataFromParent.selectedDate;
          this.selectedHour = dataFromParent.selectedHour;
        }


      }
    }
    if (this.viewMode === "Open Logs" || this.viewMode == "Closed Logs"
      || this.viewMode == "Top API" || this.viewMode == "Most Affected Page"
      || this.viewMode == "Todays Logs" || this.viewMode == "Most Affected Product"
      || this.viewMode == "Product with Highest Open Logs" || this.viewMode == "Todays Closed Logs"
      || this.viewMode == "Todays Open Logs" || this.viewMode == "Current Week Logs"
      || this.viewMode == "Error Age Data" || this.viewMode == "Open Errors by Product"
      || this.viewMode == "Weekly Trend" || this.viewMode == "Heat Map"
    ) {
      this.commonScrollHeight = this.utilityservice.updateScrollHeight();
      this.loadGridData();
    }
    else if (this.isViewClosureData == false) {
      this.gettoken();
      this.formInitiliaze();
      const data = this.config.data;
      if (data) {
        this.selectedRow = data.selectedRow[0];
      }
    }
    else {
      this.commonScrollHeight = this.utilityservice.updateScrollHeight();
      this.loadGridData();
    }
  }

  ngOnInit() {
  }


  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handling null values
      if (value1 == null && value2 != null) return -1;
      if (value1 != null && value2 == null) return 1;
      if (value1 == null && value2 == null) return 0;

      // Check if the field is createdon for date comparison
      if (event.field === 'createdon') {
        // Parse the date strings to Date objects
        const date1 = new Date(value1);
        const date2 = new Date(value2);
        return date1.getTime() - date2.getTime(); // Sort by timestamp
      }

      // Handle string comparisons
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
      }

      // Fallback to default number comparison for other types
      return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
  }

  logIdenticalGrid() {
    this.initializeIdenticalColumns();
    this.ApplicationlogsService
      .getErrorOccurenceInLogClosure(this.closureLogId).subscribe({
        next: (res: any) => {

          const data = Array.isArray(res) ? res : (res?.data || []);
          this.idArray = data.map((item: any) => item.id);
          this.identicalLogs = data.map((item: any) => ({
            ...item,
            isSelect: false
          }));

          const idList: string = this.idArray.join(", ");
          this.totalRecords = Array.isArray(res) ? this.identicalLogs.length : (res?.count ?? this.identicalLogs.length);

          const options = this.utilityservice.getOptionDropdown(this.totalRecords);

          this.identicalPaginatorArray = options.map(e => e.value);

          if (!this.identicalPaginatorArray.includes(this.identicalRowsize)) {
            this.identicalPaginatorArray.push(
              this.identicalRowsize
            );

            this.identicalPaginatorArray.sort(
              (a, b) => a - b
            );
          }
          this.identicalCurrentPageIndex = 0;

          setTimeout(() => {
            if (this.identicalDt) {
              this.identicalDt.first = 0;
            }
          }, 0);
        },

        error: (error) => {
          Swal.fire(
            'Error',
            'Unable to load identical logs.',
            'error'
          );
        }
      });
  }

  loadGridData() {
    const currentPageSize = this.rowsize;
    let payload: {};

    if (this.viewMode == "") {
      this.cols = [
        { field: 'id', header: 'Id', width: '30px', isChecked: true, class: 'headerid' },
        { field: 'organisation', header: 'Organisation', width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'userName', header: 'User/Email', width: '220px', isChecked: true, class: 'otherheader' },
        { field: 'productinitial', header: 'Product', width: '120px', isChecked: true, class: 'otherheader' },
        { field: 'createdAt', header: 'Logged On', width: '100px', isChecked: true, class: 'otherheader' }
      ];
      this._selectedColumns = this.cols;

      payload = {
        page: this.pageName,
        methodName: this.methodName
      };
    }
    else if (this.isClose == true && this.viewMode == "") {
      this.cols = [
        { field: 'id', header: 'Id', width: '30px', isChecked: true, class: 'headerid' },
        { field: 'data', header: 'Data', width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'createdAt', header: 'Logged On', width: '100px', isChecked: true, class: 'otherheader' }
      ];
      this._selectedColumns = this.cols;
    }
    else if (this.viewMode == "Closed Logs" || this.viewMode == "Todays Closed Logs") {
      this.cols = [
        { field: 'id', header: 'Id', width: '20px', isChecked: true, class: 'headerid' },
        { field: 'organisation', header: 'Organisation', width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'productinitial', header: 'Product', width: '120px', isChecked: true, class: 'otherheader' },
        { field: 'page', header: 'Page', type: 'text', sort: true, filter: true, width: '140px', isChecked: true, class: 'otherheader' },
        { field: 'methodName', header: 'API', type: 'text', sort: true, filter: true, width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'closedBy', header: 'Closed By', width: '100px', isChecked: true, class: 'otherheader' },
        { field: 'closedOn', header: 'Closed On', width: '100px', isChecked: true, class: 'otherheader' }
      ];
      this._selectedColumns = this.cols;

      payload = {
        viewMode: this.viewMode,
      };
    }
    else {
      this.cols = [
        { field: 'id', header: 'Id', width: '20px', isChecked: true, class: 'headerid' },
        { field: 'organisation', header: 'Organisation', width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'productinitial', header: 'Product', width: '120px', isChecked: true, class: 'otherheader' },
        { field: 'page', header: 'Page', type: 'text', sort: true, filter: true, width: '140px', isChecked: true, class: 'otherheader' },
        { field: 'methodName', header: 'API', type: 'text', sort: true, filter: true, width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'createdAt', header: 'Logged On', width: '100px', isChecked: true, class: 'otherheader' }
      ];
      this._selectedColumns = this.cols;

      payload = {
        viewMode: this.viewMode,
        ...((this.viewMode === "Open Errors by Product") && {
          productId: this.productId,
          orgId: this.orgId,
          fromDate: this.fromDate,
          toDate: this.toDate
        }),
        ...(this.viewMode === "Error Age Data" && {
          errorAge: this.errorAge,
          productId: this.productId,
          orgId: this.orgId,
        }),
        ...(this.viewMode === "Weekly Trend" && {
          selectedDate: this.selectedDate,
          productId: this.productId,
          orgId: this.orgId,
        }),
        ...(this.viewMode === "Heat Map" && {
          selectedDate: this.selectedDate,
          productId: this.productId,
          orgId: this.orgId,
          selectedHour: this.selectedHour
        })
      };
    }

    if (this.isClose == false) {
      this.ApplicationlogsService.getErrorOccurrences(payload).subscribe({
        next: (res: any) => {

          this.occurrenceData = (res.data || []).map(item => ({
            ...item,
            isSelect: false
          }));

          this.totalRecords = res.count ?? this.occurrenceData.length;
          this.tablecount = this.totalRecords;

          this.options = this.utilityservice.getOptionDropdown(this.totalRecords);
          this.paginatorArray = this.options.map(e => e.value);

          if (!this.paginatorArray.includes(currentPageSize)) {
            this.paginatorArray.push(currentPageSize);
            this.paginatorArray.sort((a, b) => a - b);
          }

          this.rowsize = currentPageSize;
          setTimeout(() => {
            if (this.dt) {
              this.dt.first = this.currentPageIndex;
            }
          }, 0);
        },
        error: () => {
          Swal.fire('Error', 'Unable to fetch occurrences.', 'error');
        }
      });
    }

    if (this.isClose == true) {
      this.ApplicationlogsService.getErrorOccurenceInLogClosure(this.closureLogId).subscribe({
        next: (res: any) => {

          this.identicalLogs = (res.data || []).map(item => ({
            ...item,
            isSelect: false
          }));

          this.totalRecords = res.count ?? this.identicalLogs.length;
          this.tablecount = this.totalRecords;

          this.options = this.utilityservice.getOptionDropdown(this.totalRecords);
          this.paginatorArray = this.options.map(e => e.value);

          if (!this.paginatorArray.includes(currentPageSize)) {
            this.paginatorArray.push(currentPageSize);
            this.paginatorArray.sort((a, b) => a - b);
          }

          this.rowsize = currentPageSize;
          setTimeout(() => {
            if (this.dt) {
              this.dt.first = this.currentPageIndex;
            }
          }, 0);
        },
        error: () => {
          Swal.fire('Error', 'Unable to load identical logs.', 'error');
        }
      });
    }

  }

  patchValueForms(data) {
    this.modalForm.patchValue({
      'name': data?.name,
      'activeflag': data?.activeflag
    });
  }

  formInitiliaze() {
    this.modalForm = this.fb.group({
      confirmClose: [false],
      closedOn: [new Date(), Validators.required],
      closeRemarks: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    });
  }

  closeLog() {
    if (!this.modalForm.get('confirmClose')?.value) {
      Swal.fire(
        'Confirmation Required',
        'Please confirm that the error log has been reviewed.',
        'warning'
      );
      return;
    }

    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      return;
    }

    const closedOn = new Date(this.modalForm.value.closedOn);
    const loggedOn = new Date(this.selectedRow.createdAt);

    if (closedOn < loggedOn) {
      Swal.fire(
        'Invalid Close Date',
        'Closed On cannot be earlier than the Logged On date.',
        'warning'
      );
      return;
    }

    const selectedIds = this.identicalLogs
    .filter((log: any) => log.isSelect === true)
    .map((log: any) => log.id);
    const payload = {
      id: this.selectedRow.id,
      additionalId: selectedIds.join(','),
      closedOn: formatDate(
        this.modalForm.value.closedOn,
        'yyyy-MM-dd HH:mm:ss',
        'en-US'
      ),
      remarks: this.modalForm.value.closeRemarks,
      csrftoken: this.CSRFToken
    };
    this.closeErrorLog(payload);
  }

  closeErrorLog(payload: any) {
    this.isClosingLog = true;
    this.ApplicationlogsService.closeLog(payload).subscribe({
      next: (response: any) => {
        const code = response?.response;
        this.isClosingLog = false;

        switch (code) {
          case '1':
            Swal.fire('Log Closed successfully!', '', 'success');
            this.ref.close();
            break;
          default:
            Swal.fire('Error', 'An unexpected error occurred.', 'error');
            break;
        }
      },
      error: (error) => {
        this.isClosingLog = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.error?.response || 'An unexpected error occurred.',
          footer: `Error status: ${error.status}`
        });
      }
    });
  }

  getRowClass(rowData: any): string {
    const type = rowData?.logType?.toUpperCase();
    const isClosed = Number(rowData?.isClosed);

    if (type === 'E' && isClosed === 0) {
      return 'log-error-open';
    }

    if (type === 'E' && isClosed === 1) {
      return 'log-error-closed';
    }

    return '';
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  show(title, data) {

    if (title === "Close Error Log") {
      this.onlyView = false;
      this.viewClosureData = false;
      this.isClose = true;
    }
    if (title === "Closure Data") {
      this.onlyView = true;
      this.isClose = false;
      this.viewClosureData = false;
    }

    this.ApplicationlogsService.getDataByid(data.id).subscribe(res => {

      const details = res;

      this.ref = this.dialogService.open(ErrorlogmodalComponent, {
        header: title,
        width: '70%',
        data: {
          title: title,
          selectedRow: details,
          onlyView: this.onlyView,
          isClose: this.isClose,
          isViewClosureData: this.viewClosureData,
          logId: data.id
        }
      });

      this.ref.onClose.subscribe(() => {
        this.loadGridData();
      });
    });
  }

  initializeIdenticalColumns() {
    this.identicalSelectedColumns = [
      { field: 'id', header: 'ID', width: '10px', isChecked: true, class: 'headerid' },
      { field: 'data', header: 'Data', width: '250px', isChecked: true, class: 'otherheader' },
      { field: 'createdAt', header: 'Logged On', width: '30px', isChecked: true, class: 'otherheader' }
    ];
  }

  handleIdenticalPageChange(event: any) {
    this.identicalRowsize = event.rows;
    this.identicalCurrentPageIndex = event.first;
  }
idArray: number[] = [];
  selectedId = false;

  selectRow(id, event) {
    if (event == 'all') {
      this.selectedId = !this.selectedId
      if (id == false) {
        this.identicalLogs.map(e => {
          e.isSelect = true
          this.idArray.push(e.id);
        })
      } else if (id == true) {
        this.identicalLogs.map(e => {
          e.isSelect = false
          this.idArray = [];
        })
      }

    } else {
      if (event === false || event === undefined) {
        this.idArray.push(id);
      } else {
        const index = this.idArray.indexOf(id);
        if (index > -1) {
          this.idArray.splice(index, 1);
        }
      }
    }
  }

  selectAllRows(event: any): void {
  this.selectedId = event.target.checked;

  if (this.selectedId) {
    this.identicalLogs.forEach((log: any) => {
      log.isSelect = true;
    });

    this.idArray = this.identicalLogs.map((log: any) => log.id);
  } else {
    this.identicalLogs.forEach((log: any) => {
      log.isSelect = false;
    });

    this.idArray = [];
  }
}
  
  dismiss() {
    this.ref.close();
  }
}
